import React, { FunctionComponent, useEffect } from "react";
import { useQuery } from "react-query";
import { Field, FormRenderProps, useFormState } from "react-final-form";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core";
import Autocomplete from "../../../../components/Autocomplete";
import { useUserId } from "../../../user/hooks/useUserId";
import { useManagedStudentsPage } from "../../context/managedStudentsPageContext";
import useStudentsQueries from "../../hooks/useManagedStudentsQueries";

const useStyles = makeStyles(() => ({
  mainContainer: {
    marginTop: 12,
  },
  formControl: {
    marginTop: 26,
  },
}));

export const FilterForm: FunctionComponent<FormRenderProps> = ({
  submitError,
}) => {
  const classes = useStyles();
  const { values } = useFormState();
  const { getStudents, userRole } = useManagedStudentsPage();
  const { fetchStudentCountries, fetchStudentNames } = useStudentsQueries();
  const managerId = useUserId();

  const {
    isLoading: isLoadingCountries,
    isFetching: isFetchingCountries,
    data: countriesData,
  } = useQuery<any>(`studentCountries${managerId}`, () =>
    fetchStudentCountries(managerId, userRole),
  );
  const {
    isLoading: isLoadingNames,
    isFetching: isFetchingNames,
    data: namesData,
  } = useQuery<any>(`studentNames${managerId}`, () =>
    fetchStudentNames(managerId, userRole),
  );

  useEffect(() => {
    getStudents!(values);
  }, [getStudents, values]);

  return (
    <form>
      {submitError && <Typography color="error">{submitError}</Typography>}
      <div className={classes.mainContainer}>
        <div>
          <Field
            fullWidth
            multiple={true}
            name="students"
            label="Full Name"
            placeholder="Full Name"
            disableCloseOnSelect
            options={namesData?.data}
            loading={(isFetchingNames || isLoadingNames).toString()}
            disabled={isLoadingNames || isFetchingNames}
            component={Autocomplete}
          />
        </div>
        <div className={classes.formControl}>
          <Field
            fullWidth
            multiple={true}
            name="countries"
            label="Country"
            placeholder="Country"
            disableCloseOnSelect
            options={countriesData?.data}
            loading={(isFetchingCountries || isLoadingCountries).toString()}
            disabled={isLoadingCountries || isFetchingCountries}
            component={Autocomplete}
          />
        </div>
      </div>
    </form>
  );
};
